var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-search-item',_vm._b({attrs:{"to":_vm.numberUrl}},'base-search-item',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }